import { Image } from '@website/components/media/utils/imgix';
import { Media } from '@website/types/graphqlOperations';
import Link from 'next/link';
import { Col, Row } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';

import 'react-image-lightbox/style.css';

type Props = {
  images: Pick<Media, 'file' | 'id'>[];
  groupID: string;
};

export default function MediaGallery({ images, groupID }: Props) {
  return (
    <>
      <style jsx>{`
        .more-photos:hover {
          cursor: pointer;
          box-shadow:
            0 5px 10px 0 rgba(0, 0, 0, 0.16),
            0 5px 15px 0 rgba(0, 0, 0, 0.12);
        }
      `}</style>
      <Row>
        {images.map((image) => (
          <Col key={image.id} className="p-1" xs={6} lg={3}>
            <div
              style={{
                position: 'relative',
                aspectRatio: '3/2',
              }}
            >
              <Image
                key={image.id}
                imgKey={image.file.key}
                alt={image.id}
                className="w-100 img-fluid img-gallery"
                imgixParams={{
                  ar: '3:2',
                }}
                sizes="(min-width: 1400px) 427px, (min-width: 1200px) 367px, (min-width: 992px) 307px, (min-width: 768px) 344px, (min-width: 576px) 254px, 50vw"
              />
            </div>
          </Col>
        ))}
        <Col className="d-flex p-1" xs={6} lg={3}>
          <Link passHref href={`/guest/photos/${groupID}`} legacyBehavior>
            <a
              title="Upload or view more photos"
              role="button"
              style={{
                aspectRatio: '3/2',
                cursor: 'pointer',
              }}
              className={`d-flex more-photos bg-dark text-white fw-bold align-items-center justify-content-center p-1 more-photos`}
            >
              <FaPlus className="me-2" /> View & Upload
            </a>
          </Link>
        </Col>
      </Row>
    </>
  );
}
